import React from "react";
import styles from "./listing-error-modal.module.css";
import { Modal, ModalBody, ModalHeader } from "../Modal/Modal";
import Skeleton from "../Skeleton/Skeleton";
import StatusBadge from "../StatusBadge/StatusBadge";
import IconError from "../icons/IconError";
import { FbaListingIssue } from "@/contexts/FbaListingContext";
import { SellerProductData } from "@/contexts/InventoryContext";
import { productConditionToString } from "@/app/fba/utils";

type ListingErrorModalProps = {
  open: boolean,
  setOpen: (val: boolean) => void;
  sellerData: SellerProductData;
};

const ListingErrorModal = ({
  open,
  setOpen,
  sellerData,
}: ListingErrorModalProps) => {
  const errors: FbaListingIssue[] = ((typeof sellerData?.issues === "string" ? JSON.parse(sellerData?.issues ?? "[]") ?? [] : sellerData?.issues ?? []) as FbaListingIssue[]).filter(err => err.severity === "ERROR");

  return (
    <Modal
      open={open}
      onOpenChange={() => {}}
      onClose={() => setOpen(false)}
      className={styles.modal}
    >
      <ModalHeader>
        <div className={styles.header}>
          {sellerData.image ? (
            <img
              src={sellerData.image}
              width="64px"
              height="64px"
              alt={sellerData.name}
              className={styles.inventoryImage}
            />
          ): (
            <div className={styles.skeletonContainer}>
              <Skeleton type="image" disableShimmer width={64} height={64} />
            </div>
          )}
          <div className={styles.metaDataContainer}>
            <span className={styles.metaDataTitle}>
              {sellerData.name}
            </span>
            <div className={styles.metaDataSubContainer}>
              <div className={styles.skuAndCondition}>
                <span className={styles.subTitleContainer}>
                  <span className={styles.subMetaTitle}>
                    SKU:
                  </span>
                  <span className={styles.subMetaValue}>
                    {sellerData.sku}
                  </span>
                </span>
                <span className={styles.dot}>
                  •
                </span>
                <span className={styles.subTitleContainer}>
                  <span className={styles.subMetaTitle}>
                    Condition:
                  </span>
                  <span className={styles.subMetaValue}>
                    {productConditionToString(sellerData.condition)}
                  </span>
                </span>
                <StatusBadge
                  status={sellerData.isFBM ? "danger" : "warning"}
                  label={sellerData.isFBM ? "FBM" : "FBA"}
                  className={styles.statusBadge}
                />
              </div>
              <span className={styles.subTitleContainer}>
                <span className={styles.subMetaTitle}>
                  ASIN:
                </span>
                <span className={styles.subMetaValue}>
                  {sellerData.asin}
                </span>
              </span>
            </div>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className={styles.modelBody}>
        {errors.map((error, index) => {
          return (
            <div key={index} className={`${styles.errorContainer} ${index === errors.length - 1 ? styles.lastError : ""}`}>
              <IconError size={22} className={styles.errorIcon} currentColor />
              <h3 className={styles.errorCodeText}>ERROR: [{error.code}]</h3>
              <h5 className={styles.errorText}>{error.message}</h5>
            </div>
          );
        })}
      </ModalBody>
    </Modal>
  );
};

export default ListingErrorModal;